export default __webpack_public_path__ + "static/media/No55.0ba4e070.png";